import type {Question} from '@cp/model';
import {questionCheckWithRules} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCheckQuestionWithRules() {
  const {
    fn: checkQuestionWithRules,
    loading,
    error,
  } = useFunctionWrap(
    async (moduleId: string, questionId: string): Promise<Question> =>
      questionCheckWithRules({moduleId, questionId}) as Promise<Question>,
  );

  return {
    checkQuestionWithRules,
    loading,
    error,
  };
}
